module.exports = __webpack_public_path__ + "media/14.523b6f6b.mp3";